import { Component, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from './services/theme.service';

import { IPageComponent } from './interfaces/ipagecomponent';

import { ParametrageApplicatifService } from './services/parametrage-applicatif.service';

import { Comparaisons } from './tools/Comparaisons';

/**
 * Composant principal de l'application
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'mr-fournisseur-web';
    afficherHeader: boolean = false;
    afficherMessages: boolean = false;

    rubanLabel: string  = '';
    rubanCssClass: string  = '';

    version: string = '';
    feedbackActif: string = '';

    afficherFeedback: boolean = false;

    /**
     * Constructeur
     */
    constructor(@Inject(ParametrageApplicatifService) private parametrageApplicatifService: ParametrageApplicatifService, private theme: ThemeService)
    {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.recupererFeedback();
        this.recupererVersion();
        this.recupererEnvironnement();

        // If Es or Pt load inpost, else load mr
        //const currentUrl = window.location.href;
        const currentUrl = window.location.host;
        const language = currentUrl.split('.').pop().toLowerCase();
        const theme = language === 'es' || language === 'pt' ? 'inpost' : 'mr';
        this.theme.loadTheme(theme);
        
    }

    /**
     * A l'activation du composant
     * @param componentRef
     */
    onActivate(componentRef) {
        let estPage: boolean = (componentRef instanceof IPageComponent);
        // Afficher le header si le composant est une page
        this.afficherHeader = estPage;
        // Afficher le feedback si le composant est une page
        this.afficherFeedback = estPage && Comparaisons.testVrai(this.feedbackActif);
        // Afficher les messages si le composant est une page
        this.afficherMessages = estPage;
    }

    /**
     * Récupérer la version
     */
    private recupererVersion() {
        let version = this.parametrageApplicatifService.obtenir('version');
        this.version = version;
    }

    /**
     * Récupérer l'environnement (et le ruban)
     */
    private recupererEnvironnement() {
        let env = this.parametrageApplicatifService.obtenir('environnement');
        if (env == 'DEV') {
            this.rubanLabel = 'Version Développement';
            this.rubanCssClass = 'ruban-dev';
        }
        else if (env == 'PREVIEW') {
            this.rubanLabel = 'Version Preview';
            this.rubanCssClass = 'ruban-preview';
        }
    }

    /**
     * Récupérer le feedback
     */
    private recupererFeedback() {
        this.feedbackActif = this.parametrageApplicatifService.obtenir('feedback.actif');
    }
}
